import React,{ Component } from "react";
import {Button, Segment, Rail, Input, Icon, Table, Pagination, Header, Select,Modal,Label } from "semantic-ui-react";
import Currency from "react-currency-formatter";
import client from "../../shared/feathers";
let types = {commercial:"Unternehmen",private:"Privat"}
function list_to_tree(list) {
    var map = {}, node, roots = [], i;
    for (i = 0; i < list.length; i += 1) { map[list[i].id] = i; list[i].children = []; }
    for (i = 0; i < list.length; i += 1) { node = list[i]; if (node.category_id ) { list[map[node.category_id]].children.push(node); } else { roots.push(node);}}
    return roots;
}
class ProductsAdd extends Component{

    state={
        query:{},
        data:{
            total:1,
            limit:1,
            data:[]
        },
        categories:[],
        catNames:{},
        page: 1,
        loading:true,selected:[]
    }
    componentDidMount(){
        document.title = 'Produkte';
        this.update()
    }

    changePage(event,data){
        this.setState({loading:true,page:data.activePage},()=>this.update())
    }
    update(){
        this.setState({loading:true})
        if(this.reactive){this.reactive.unsubscribe()}
        this.reactive = client.service("products").watch().find({query: {$and:[...Object.values(this.state.query)],$skip:(this.state.page * this.state.data.limit)-this.state.data.limit }}).subscribe(async data=>this.setState({data,loading:false}))
    }
    componentWillUnmount(){
        if(this.reactive){this.reactive.unsubscribe()}
    }
    changeFilter(name,value){
        this.setState({query:{...this.state.query,[name]:{[name]:{$like: "%"+value+"%" }}}}, ()=>this.update())
    }

    toTreeSelect(obj,padding=" "){
        return obj.flatMap((elm, id) => [
            {key: elm.id, text: padding+" "+elm.name+" ("+elm.id+")", value: elm.id},
            ...this.toTreeSelect(elm.children,padding+"--")
        ])
    }
    catToObj(obj){
        let result = {}
        for (let entry of obj){
            result[entry.id]=entry.name
        } return result
    }
    selectSingle(el){
      console.log(el)
      let selected = [...this.state.selected,el]
      this.setState({selected})
    }
    deleteSingle(id){
      this.state.selected.splice(id,1)
      this.setState({selected:[...this.state.selected]})
    }
    // TODO: Merfach auswahl
    render(){
        return ( 
            <Modal
                style={{width: "87%"}}
                size="large"
                centered={false} closeIcon
                open={this.props.open}
                onClose={() => this.props.setOpen(false)}
                onOpen={() => this.props.setOpen(true)}
            >
            <Modal.Header>Produkt hinzufügen</Modal.Header>
                <Modal.Content>
                  <b>Ausgewählt: </b>
                  {this.state.selected.map((entry, id) => <Label>{entry.sku} - {entry.product_name} <Icon onClick={id=>this.deleteSingle(id)} color="red" name='delete' /></Label>)}

                  <Rail  internal position='right'>
                    <Segment style={{borderBottom:0,textAlign:"right"}}>
                      <Button onClick={()=>this.props.addProduct(this.state.selected)} primary>Speichern</Button>
                    </Segment>
                  </Rail>
                </Modal.Content>
                <Modal.Content   loading={this.state.loading} style={{padding:0}}>
                    <Table selectable celled >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell collapsing>ID</Table.HeaderCell>
                                <Table.HeaderCell>Kanal</Table.HeaderCell>
                                <Table.HeaderCell>Produkt</Table.HeaderCell>
                                <Table.HeaderCell>Vertriebslinie</Table.HeaderCell>
                                <Table.HeaderCell>Filiale</Table.HeaderCell>
                                <Table.HeaderCell>Format/Fläche</Table.HeaderCell>
                                <Table.HeaderCell>Einzelpreis</Table.HeaderCell>
                                <Table.HeaderCell>Einheit</Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell collapsing style={{padding:5, backgroundColor:'#fff'}}><Input onChange={(e,{name,value})=>this.changeFilter(name,value)}  name="sku" size="tiny" fluid transparent size="mini" /></Table.HeaderCell>
                                <Table.HeaderCell style={{padding:0, backgroundColor:'#fff'}}><Select style={{border:"0",height:20}} options={[
                                    {key: 1, text: "Online", value: "Online"},
                                    {key: 2, text: "Direct", value: "Direct"},
                                    {key: 3, text: "Store", value: "Store"},
                                    {key: 4, text: "Social Media", value: "Social Media"},
                                    {key: 5, text: "Event", value: "Event"},
                                    {key: 6, text: "Analytics", value: "Analytics"}
                                ]} onChange={(e,{name,value})=>this.changeFilter(name,value)} clearable text='' transparent name="channel" fluid /></Table.HeaderCell>
                                <Table.HeaderCell style={{padding:5, backgroundColor:'#fff'}}><Input onChange={(e,{name,value})=>this.changeFilter(name,value)} name="product_name" icon="search" fluid transparent size="mini" /></Table.HeaderCell>
                                <Table.HeaderCell style={{padding:5, backgroundColor:'#fff'}}><Input onChange={(e,{name,value})=>this.changeFilter(name,value)} name="salesline" icon="search" fluid transparent size="mini" /></Table.HeaderCell>
                                <Table.HeaderCell style={{padding:5, backgroundColor:'#fff'}}><Input onChange={(e,{name,value})=>this.changeFilter(name,value)} name="department" icon="search" fluid transparent size="mini" /></Table.HeaderCell>
                                <Table.HeaderCell style={{padding:5, backgroundColor:'#fff'}}><Input onChange={(e,{name,value})=>this.changeFilter(name,value)} name="format" icon="search" fluid transparent size="mini" /></Table.HeaderCell>
                                <Table.HeaderCell style={{padding:5, backgroundColor:'#fff'}}><Input onChange={(e,{name,value})=>this.changeFilter(name,value)} name="single_price" icon="search" fluid transparent size="mini" /></Table.HeaderCell>
                                <Table.HeaderCell style={{padding:5, backgroundColor:'#fff'}}><Input onChange={(e,{name,value})=>this.changeFilter(name,value)} name="unit2" icon="search" fluid transparent size="mini" /></Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        {this.state.data.data.length >0 && <Table.Body>
                            {this.state.data.data.map((entry, id) =>
                                <Table.Row key={entry.id} style={{cursor:"pointer"}} onClick={()=>this.selectSingle({...entry})}>
                                    <Table.Cell>{entry.sku}</Table.Cell>
                                    <Table.Cell>{entry.channel}</Table.Cell>
                                    <Table.Cell>{entry.product_name}</Table.Cell>
                                    <Table.Cell>{entry.salesline}</Table.Cell>
                                    <Table.Cell>{entry.department}</Table.Cell>
                                    <Table.Cell>{entry.format}</Table.Cell>
                                    <Table.Cell><Currency quantity={entry.single_price} currency="EUR" /></Table.Cell>
                                    <Table.Cell>{entry.unit2}</Table.Cell>
                                </Table.Row>
                            ) }
                        </Table.Body>}
                    </Table>

                    {this.state.data.data.length ==0 &&<Segment placeholder attached="bottom">
                        <Header icon><Icon name='search' /> Es wurde kein Produkt gefunden </Header>
                    </Segment>}
                </Modal.Content >
                <Pagination 
                    onPageChange={this.changePage.bind(this)}
                    attached="bottom" 
                    boundaryRange={2} 
                    siblingRange={2}
                    fluid 
                    defaultActivePage={this.state.page} 
                    totalPages={Math.ceil(this.state.data.total / this.state.data.limit)} />
            </Modal>
        )
    }
}

export default ProductsAdd